'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

var _isMatch = require('lodash/isMatch');

var _isMatch2 = _interopRequireDefault(_isMatch);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectAutoSizer = function (_PureComponent) {
    _inherits(SelectAutoSizer, _PureComponent);

    function SelectAutoSizer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SelectAutoSizer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectAutoSizer.__proto__ || Object.getPrototypeOf(SelectAutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            measured: false,
            height: null,
            width: null
        }, _this.checkSize = function () {
            // TODO: width and height should be calculated without padding
            var _this$parentRef = _this.parentRef,
                clientWidth = _this$parentRef.clientWidth,
                clientHeight = _this$parentRef.clientHeight;

            var _this$props$sizeProce = _this.props.sizeProcessor({
                height: clientHeight,
                width: clientWidth
            }),
                height = _this$props$sizeProce.height,
                width = _this$props$sizeProce.width;

            var state = {
                height: height,
                width: width,
                measured: true
            };
            if ((0, _isMatch2.default)(_this.state, state)) {
                return;
            }
            _this.setState(state, _this.props.onDidResize);
        }, _this.checkSizeThrottled = (0, _throttle2.default)(_this.checkSize, 100, { leading: false, trailing: true }), _this.handleResize = _this.checkSizeThrottled, _this.handleOrientationChange = function () {
            // Mobile devices (iOS 10.3.1) don't return valid parent element size
            // right after the screen orientation change. It also fires the resize event
            // with the same issue.
            // So we need to check size after some time past after event.
            // The only robust way to get new screen size I've found is to
            // check the size several times (during at least 500ms).
            // We could do this just once after 500ms past but it makes the UX worse.
            // I've also tried to check repeatedly until the first size change happened
            // but there were situations on iOS when it returns new height
            // with old width.
            var count = 0;
            var checkSizeRepeated = function checkSizeRepeated() {
                _this.checkSizeThrottled();
                count += 1;
                if (count < 5) {
                    setTimeout(checkSizeRepeated, 100);
                }
            };
            checkSizeRepeated();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectAutoSizer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.parentRef = this.rootRef.parentNode;
            this.checkSize();

            window.addEventListener('resize', this.handleResize);
            window.addEventListener('orientationchange', this.handleOrientationChange);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.checkSize();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('orientationchange', this.handleOrientationChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                measured = _state.measured,
                height = _state.height,
                width = _state.width;

            return _react2.default.createElement(
                'div',
                { ref: function ref(_ref2) {
                        return _this2.rootRef = _ref2;
                    } },
                measured ? this.props.contentRenderer({ height: height, width: width })
                // Hack for IE11 to get correct clientWidth
                : _react2.default.createElement(
                    'div',
                    null,
                    '\xA0'
                )
            );
        }
    }]);

    return SelectAutoSizer;
}(_react.PureComponent);

SelectAutoSizer.propTypes = {
    sizeProcessor: _react.PropTypes.func,
    contentRenderer: _react.PropTypes.func.isRequired,
    onDidResize: _react.PropTypes.func
};
SelectAutoSizer.defaultProps = {
    sizeProcessor: function sizeProcessor(obj) {
        return obj;
    },
    onDidResize: function onDidResize() {
        return null;
    }
};
exports.default = SelectAutoSizer;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/SelectAutoSizer.js
// module id = 2271
// module chunks = 0